/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowRequestManagementStatusMapping {
    getFixupPrototypeFunction() { return ServiceNowRequestManagementStatusMapping.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowRequestManagementStatusMapping>): ServiceNowRequestManagementStatusMapping {
        let obj = Object.assign(new ServiceNowRequestManagementStatusMapping(), model);
        ServiceNowRequestManagementStatusMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowRequestManagementStatusMapping>): ServiceNowRequestManagementStatusMapping {
        if (!model) return null;
        return ServiceNowRequestManagementStatusMapping.newInstance(<ServiceNowRequestManagementStatusMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowRequestManagementStatusMapping) {
        if (!obj) return;

        models.ServiceNowRequestManagementStatusMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowRequestManagementStatusMapping): boolean {
        Object.setPrototypeOf(obj, ServiceNowRequestManagementStatusMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Service Now status for Request Management
     */
    service_now_status: models.ServiceNowRequestManagementStatus;

    /**
     * Corestack status for Request Management
     */
    corestack_status: string;

}
